/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-array-index-key */
import React, { useContext } from 'react';
import { Typography, Button } from '@material-ui/core';
import { useStyles } from '@mummssoftware/common-ui/VisitAttributeSelector';
import { RecordVisitButtonsDiv } from '@mummssoftware/common-ui/DeleteVisitConfirmation';
import { HopeGlobalContext } from '@mummssoftware/global-context';
import { VisitContext } from '../Context/contexts/VisitContext';
import { SHOW_CONFIRM_VISIT, STOP_VISIT } from '../Context/constants';
import defaults from '../../translations/en.json';

export const ConfirmRecordVisit = () => {
  const {
    dispatchVisit,
    confirmVisitMissingDoc,
    confirmVisitMissingHCPCS,
  } = useContext(VisitContext);
  const { isHopeVisit, visitRequiresSFV } = useContext(HopeGlobalContext);

  const classes = useStyles();

  const recordVisit = () => {
    dispatchVisit({
      type: STOP_VISIT,
      payload: true,
    });
  };
  const cancelVisit = () => {
    dispatchVisit({
      type: SHOW_CONFIRM_VISIT,
      payload: false,
    });
  };

  return (
    <>
      {isHopeVisit && visitRequiresSFV ? (
        <div
          style={{
            maxWidth: '20vw',
            minHeight: '10hv',
            paddingTop: '7px',
          }}
        >
          {defaults.SIAEmailNotification}
        </div>
      ) : (
        <>
          {confirmVisitMissingDoc && (
            <Typography>{defaults.confirmRecordVisit}</Typography>
          )}
          {confirmVisitMissingHCPCS && (
            <Typography color="error">{defaults.noHCPCSRecorded}</Typography>
          )}
        </>
      )}

      <RecordVisitButtonsDiv>
        <Button
          title={defaults.submitVisit}
          size="small"
          variant="contained"
          color="primary"
          onClick={cancelVisit}
          classes={{
            root: classes.button,
          }}
        >
          {defaults.cancel}
        </Button>
        <Button
          title={defaults.submitVisit}
          size="small"
          variant="contained"
          color="primary"
          onClick={recordVisit}
          classes={{
            root: classes.button,
          }}
        >
          {defaults.submitVisit}
        </Button>
      </RecordVisitButtonsDiv>
    </>
  );
};
